export const ROUTES = {
	INACTIVE_USER: 'inactive-user',
	CUSTOMERS: 'customers',
    USERS: 'users',
	PROFILE: 'profile',
	RELEASE_NOTES: 'release-notes',
	ACCOUNT: 'accounts',
	DEFAULT_ROUTE: '/',
	SALES_REPORT: 'SalesReport',
	ACCOUNT_DEAL_INFORMATION: 'AccountDealInformation',
	ACCOUNT_DETAILS: 'accounts/:id',
	BILLING: 'billing'
}
